import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { GroupService } from '../../services/group.service';
import { Group } from '../../models/group.model';
import { ResultCode } from '../../enums/resultcode.enum';

@Component({
    selector: 'group-detail',
    templateUrl: './group-detail.component.html',
    styleUrls: ['./group-detail.component.css'],
    providers: [GroupService, ErrorHandler]
})
export class GroupDetailComponent implements OnInit {
    group: Group;
    isDataAvailable = false;
    messages: Array<string>;
    private groupId: string;

    constructor(
        private groupService: GroupService,
        private errorHandler: ErrorHandler,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.group = new Group();
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params['groupId'] && params['groupId'] !== '0') {
                this.groupService.getGroup(params['groupId'])
                    .then(group => {
                            this.group = group;
                            this.isDataAvailable = true;
                        }
                    )
                    .catch(error => {
                        this.errorHandler.do(error);
                    });
                } else {
                    this.isDataAvailable = true;
                }
        });
    }

    save(): void {
        if (this.group.id === undefined) {
            this.insert();
        } else {
            this.update();
        }
    }

    private update(): void {
        this.isDataAvailable = false;
        this.groupService.updateGroup(this.group)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['groups']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private insert(): void {
        this.isDataAvailable = false;
        this.groupService.addGroup(this.group)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['groups']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    cancel(): void {
        this.router.navigate(['groups']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/group-detail/group-detail.component.ts